import FeatureMobileLayout from './FeatureMobileLayout';
export default FeatureMobileLayout ;